import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchDict } from '@/api/MLXC/countryServe/partyManage';
import { fetchList, fetchDelete, lightOpenAll as _lightOpenAll, lightCloseAll as _lightCloseAll, orderLightOpenAll } from '@/api/PMS/venueArea/venueArea';
import waves from '@/directive/waves'; // 水波纹指令

import add from './add';
import place from '../venueManage/index';
import placePrice from '../venueAreaCharge/index';
export default {
  name: 'ComplexTable',
  components: {
    add: add,
    place: place,
    placePrice: placePrice
  },
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10
      },
      title: '',
      Id: -1,
      multipleSelection: [],
      dialogFormVisible: false,
      dialogPlaceFormVisible: false,
      dialogPlacePriceFormVisible: false,
      areaTypeOptions: [],
      areaUseOptions: [],
      pricingMethodOptions: []
    };
  },
  created: function created() {
    this.getAreaType();
    this.getPricingMethodType();
    this.getList();
  },
  methods: {
    getAreaType: function getAreaType() {
      var _this = this;

      fetchDict({
        dicType: 'area_type'
      }).then(function (res) {
        _this.areaTypeOptions = res.data.data;
      });
    },
    getUseType: function getUseType() {
      var _this2 = this;

      fetchDict({
        dicType: 'area_use',
        upDicValue: this.listQuery.areaType
      }).then(function (res) {
        _this2.areaUseOptions = res.data.data;
      });
    },
    getPricingMethodType: function getPricingMethodType() {
      var _this3 = this;

      fetchDict({
        dicType: 'pricing_method'
      }).then(function (res) {
        _this3.pricingMethodOptions = res.data.data;
      });
    },
    handCancle: function handCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogFormVisible = false;
      this.dialogPlaceFormVisible = false;
      this.dialogPlacePriceFormVisible = false;
    },
    getList: function getList() {
      var _this4 = this;

      this.listLoading = true;
      fetchList(this.listQuery).then(function (response) {
        _this4.list = response.data.data;
        _this4.total = response.data.total;
        _this4.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 创建
    handleCreate: function handleCreate() {
      this.Id = -1;
      this.title = '添加';
      this.dialogFormVisible = true;
    },
    // 编辑
    handleUpdate: function handleUpdate(Id) {
      this.Id = Id;
      this.title = '编辑';
      this.dialogFormVisible = true;
    },
    lightOpenAll: function lightOpenAll(Id) {
      var _this5 = this;

      this.$confirm('确认要全开灯, 是否继续?', "提示").then(function () {
        var queryData = {
          id: Id
        };

        _lightOpenAll(queryData).then(function (response) {
          if (response.code == 200) {
            _this5.Alert({
              alertType: "add",
              message: '操作成功'
            });
          }
        });
      });
    },
    handleOrderLightOpen: function handleOrderLightOpen() {
      var _this6 = this;

      this.$confirm('确认要打开当前订单灯控, 是否继续?', "提示").then(function () {
        orderLightOpenAll().then(function (response) {
          if (response.code == 200) {
            _this6.Alert({
              alertType: "add",
              message: '操作成功'
            });
          }
        });
      });
    },
    lightCloseAll: function lightCloseAll(Id) {
      var _this7 = this;

      this.$confirm('确认要全关灯, 是否继续?', "提示").then(function () {
        var queryData = {
          id: Id
        };

        _lightCloseAll(queryData).then(function (response) {
          if (response.code == 200) {
            _this7.Alert({
              alertType: "add",
              message: '操作成功'
            });
          }
        });
      });
    },
    handlePlace: function handlePlace(Id) {
      this.Id = Id;
      this.title = '场地管理';
      this.dialogPlaceFormVisible = true;
    },
    handlePlacePrice: function handlePlacePrice(Id) {
      this.Id = Id;
      this.title = '区域收费明细配置';
      this.dialogPlacePriceFormVisible = true;
    },
    delete: function _delete(Ids) {
      var _this8 = this;

      if (Ids.length > 0) {
        this.$confirm('你确定是要删除这些记录, 是否继续?', '提示').then(function () {
          fetchDelete(Ids).then(function (response) {
            _this8.getList();

            _this8.Alert({
              alertType: 'delete'
            });
          });
        });
      } else {
        this.Alert({
          alertType: 'nodata'
        });
      }
    },
    handleDelete: function handleDelete(Id) {
      var Ids = [];
      Ids.push(Id);
      this.delete(Ids);
    },
    handleDeletes: function handleDeletes() {
      var Ids = [];
      this.multipleSelection.forEach(function (row) {
        Ids.push(row.id);
      });
      this.delete(Ids);
    }
  }
};